<div class="bdo-container bdo-space--bottom">
  <h3>{{ 'register.title' | translate }}</h3>
</div>

<bdo-register-form [activationState]="activationState"></bdo-register-form>
